import React from 'react';
import { FormattedMessage } from 'react-intl';

import type { OrderRegionDetailResponse } from '../../openapi/types/OrderRegionDetail';

import { orderMessages } from './orderMessages';

type AreasSummaryProps = {
  cities?: OrderRegionDetailResponse[];
  cadasters?: OrderRegionDetailResponse[];
  orps?: OrderRegionDetailResponse[];
  momcs?: OrderRegionDetailResponse[];
  regions?: OrderRegionDetailResponse[];
  customAreasCount: number;
};

export const AreasSummary: React.FC<AreasSummaryProps> = (props) => {
  if (
    !(
      !!props.cities?.length ||
      !!props.cadasters?.length ||
      !!props.orps?.length ||
      !!props.momcs?.length ||
      !!props.regions?.length ||
      props.customAreasCount > 0
    )
  ) {
    return null;
  }

  return (
    <dl className='sg-u-vs-1/2'>
      {!!props.momcs?.length && (
        <div>
          <dt className='sg-u-type-bold sg-a-d-ib'>
            <FormattedMessage {...orderMessages.momc} />
          </dt>
          &nbsp;&ndash;&nbsp;
          <dd className='sg-a-d-ib'>{props.momcs.map((momc) => momc.name).join(', ')}</dd>
        </div>
      )}
      {!!props.cities?.length && (
        <div>
          <dt className='sg-u-type-bold sg-a-d-ib'>
            <FormattedMessage {...orderMessages.city} />
          </dt>
          &nbsp;&ndash;&nbsp;
          <dd className='sg-a-d-ib'>{props.cities.map((city) => city.name).join(', ')}</dd>
        </div>
      )}
      {!!props.cadasters?.length && (
        <div>
          <dt className='sg-u-type-bold sg-a-d-ib'>
            <FormattedMessage {...orderMessages.cadaster} />
          </dt>
          &nbsp;&ndash;&nbsp;
          <dd className='sg-a-d-ib'>
            {props.cadasters.map((cadaster) => cadaster.name).join(', ')}
          </dd>
        </div>
      )}
      {!!props.orps?.length && (
        <div>
          <dt className='sg-u-type-bold sg-a-d-ib'>
            <FormattedMessage {...orderMessages.orp} />
          </dt>
          &nbsp;&ndash;&nbsp;
          <dd className='sg-a-d-ib'>{props.orps.map((orp) => orp.name).join(', ')}</dd>
        </div>
      )}
      {!!props.regions?.length && (
        <div>
          <dt className='sg-u-type-bold sg-a-d-ib'>
            <FormattedMessage {...orderMessages.region} />
          </dt>
          &nbsp;&ndash;&nbsp;
          <dd className='sg-a-d-ib'>{props.regions.map((region) => region.name).join(', ')}</dd>
        </div>
      )}
      {props.customAreasCount > 0 && (
        <p>
          <FormattedMessage
            {...orderMessages.drawnAreas}
            values={{ customAreasCount: props.customAreasCount }}
          />
        </p>
      )}
    </dl>
  );
};
